import {Measure} from "../../services/GreenLoanService";
import {MeasureCard} from "../MeasureCard";
import {Dispatch, SetStateAction} from "react";

interface Props {
    measures: Measure[],
    expandedMeasureNumber: number | null,
    setExpandedMeasureNumber: Dispatch<SetStateAction<number | null>>
}

export function MeasureList(props: Props) {
    const {
        measures,
        expandedMeasureNumber,
        setExpandedMeasureNumber
    } = props
    return (
        <div>
            {measures.map(measure =>
                <MeasureCard key={measure.measureNumber}
                             measure={measure}
                             expandedMeasureNumber={expandedMeasureNumber}
                             setExpandedMeasureNumber={setExpandedMeasureNumber}
                />
            )}
        </div>
    )
}